
import angular from "angular";

import TrackingCalendarViewModuleConstants from "./Constants";
import TrackingCalendarEventViewConstants from "./TrackingCalendarEventViewConstants";

import uiRouter from "@uirouter/angularjs";

import Assert from "tbAssert";
import DependencyListBuilder from "../../utility/DependencyListBuilder";

import TrackingCalendarViewController from "./TrackingCalendarViewController";

import TrackingCalendarDataServiceModule from "../../services/TrackingCalendarDataService";

//import AuthenticationGuard from "tbClient/services/AuthenticationGuard";

import NormalizeCalendarParameters from "./NormalizeCalendarParameters";

function NormalizeCalendarParametersResolvable($transition$) {
    let calendarStateParams = Object.assign({}, $transition$.params());
    return NormalizeCalendarParameters(calendarStateParams);
}

NormalizeCalendarParametersResolvable.$inject = ["$transition$"];

function BuildCalendarParamsFromDirectEventId($log, $transition$, TrackingCalendarData) {

    Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
    Assert.StrictAssert($transition$ != null, "Assertion Failure: Missing UI Router Transition Input Dependency");
    Assert.StrictAssert(TrackingCalendarData != null, "Assertion Failure: Missing Tracking Calendar Data Service Dependency");

    let currentStateParams = Object.assign({}, $transition$.params());

    let eventIdNum = parseInt(currentStateParams.eventId, 10);
    if (Number.isInteger(eventIdNum)) {
        return TrackingCalendarData
            .getEvent(eventIdNum)
            .then(function(eventData) {
                if ((eventData != null) &&
                    (angular.isDefined(eventData.eventStart)))
                {
                    let evtStart = eventData.eventStart;
                    let calendarParamData = {
                        calendarViewType: "day",
                        year: evtStart.year(),
                        month: evtStart.month() + 1,
                        day: evtStart.date(),
                        selectedEventId: eventData.EventId
                    };

                    return calendarParamData;
                }
                else {
                    return {
                        calendarViewType: null,
                        year: null,
                        month: null,
                        day: null,
                        selectedEventId: undefined
                    };
                }

            }, function(errorMessage) {
                $log.error("Error retrieving chosen event");
                $log.error(errorMessage);
                return {
                    calendarViewType: null,
                    year: null,
                    month: null,
                    day: null,
                    selectedEventId: undefined,
                    errorMessage: errorMessage
                };
            });
    }
    else {
        let thisDay = new Date();
        return {
            calendarViewType: "default",
            year: thisDay.getFullYear(),
            month: thisDay.getMonth() + 1,
            day: thisDay.getDate(),
            selectedEventId: undefined,
            errorMessage: "Invalid event id."
        };
    }
}

BuildCalendarParamsFromDirectEventId.$inject = [ "$log", "$transition$", "TrackingCalendarData" ];

const trackingCalendarViewTemplate = TrackingCalendarViewController.template;

function TrackingCalendarViewConfiguration($stateProvider) {

    Assert.StrictAssert($stateProvider != null, "Assertion Failure: Missing UI Router State Provider Dependency");

    $stateProvider
        .state(TrackingCalendarViewModuleConstants.rootStateName, {
            url: "/tracking-calendar/{calendarViewType}/{year}/{month}/{day}",
            template: trackingCalendarViewTemplate,
            controller: TrackingCalendarViewController,
            controllerAs: TrackingCalendarViewController.controllerAs,
            params: {
                calendarViewType: {squash: true, value: null, dynamic: true},
                year: { squash: true, value: null, dynamic: true},
                month: {squash: true, value: null, dynamic: true},
                day: {squash: true, value: null, dynamic: true}
            },
            data: {
                requiresLogin: true
            },
            resolve: {
                calendarParams: NormalizeCalendarParametersResolvable
            }
        })
        .state(TrackingCalendarEventViewConstants.stateName, {
            url: "^/tracking-calendar-event/{eventId}",
            template: trackingCalendarViewTemplate,
            controller: TrackingCalendarViewController,
            controllerAs: TrackingCalendarViewController.controllerAs,
            params: {
                eventId: { squash: false }
            },
            data: {
                requiresLogin: true
            },
            resolve: {
                calendarParams: BuildCalendarParamsFromDirectEventId
            }
        });
}

TrackingCalendarViewConfiguration.$inject = [ "$stateProvider" ];

TrackingCalendarViewConfiguration.dependencies = DependencyListBuilder([
    TrackingCalendarViewController.dependencies,
    //AuthenticationGuard.dependencies,
    [
        uiRouter,
        TrackingCalendarDataServiceModule
    ]
]);

export default TrackingCalendarViewConfiguration;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/TrackingCalendarViewConfiguration.js
// module id = IXZ5
// module chunks = 1